// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customize pagination bullets */
.swiper-pagination-bullet {
  width: 7px;
  height: 7px;
  background-color: rgb(0, 0, 0);
  opacity: 0.4;
}

/* Change the color of the active bullet */
.swiper-pagination-bullet-active {
  background-color: rgb(0, 0, 0);
  opacity: 1;
  width: 22px;
  border-radius: 9999px;
}

/* Navigation arrows styling */
.tf-sw-effect .swiper-button-next,
.tf-sw-effect .swiper-button-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
  z-index: 3;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}

.tf-sw-effect .swiper-button-next:hover,
.tf-sw-effect .swiper-button-prev:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
}

.tf-sw-effect .swiper-button-next::after,
.tf-sw-effect .swiper-button-prev::after {
  font-size: 18px;
  color: #000;
  font-weight: 600;
  line-height: 1;
}

.tf-sw-effect .swiper-button-prev {
  left: 6px;
}

.tf-sw-effect .swiper-button-next {
  right: 6px;
  top: 50%;
}



.tf-sw-effect .swiper-button-prev:disabled,
.tf-sw-effect .swiper-button-next:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.banner-img {
  height: auto;
}

@media only screen and (max-width: 900px) {
  .banner-img {
    height: 100%;
  }

  .tf-sw-effect .swiper-button-next,
  .tf-sw-effect .swiper-button-prev {
    width: 36px;
    height: 36px;
  }

  .tf-sw-effect .swiper-button-next::after,
  .tf-sw-effect .swiper-button-prev::after {
    font-size: 16px;
  }

  .tf-sw-effect .swiper-button-prev {
    left: 12px;
  }

  .tf-sw-effect .swiper-button-next {
    right: 12px;
    top: 50%;
  }
}

@media only screen and (max-width: 480px) {
  .tf-sw-effect .swiper-button-next,
  .tf-sw-effect .swiper-button-prev {
    width: 32px;
    height: 32px;
  }

  .tf-sw-effect .swiper-button-next::after,
  .tf-sw-effect .swiper-button-prev::after {
    font-size: 14px;
  }

  .tf-sw-effect .swiper-button-prev {
    left: 8px;
  }

  .tf-sw-effect .swiper-button-next {
    right: 8px;
    top: 50%;
  }
}


`, "",{"version":3,"sources":["webpack://./src/features/view/public/landingPage/components/Banner.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,0CAA0C;AAC5C;;AAEA;;EAEE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;;;AAIA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;AACF","sourcesContent":["/* Customize pagination bullets */\n.swiper-pagination-bullet {\n  width: 7px;\n  height: 7px;\n  background-color: rgb(0, 0, 0);\n  opacity: 0.4;\n}\n\n/* Change the color of the active bullet */\n.swiper-pagination-bullet-active {\n  background-color: rgb(0, 0, 0);\n  opacity: 1;\n  width: 22px;\n  border-radius: 9999px;\n}\n\n/* Navigation arrows styling */\n.tf-sw-effect .swiper-button-next,\n.tf-sw-effect .swiper-button-prev {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 42px;\n  height: 42px;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  z-index: 3;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n}\n\n.tf-sw-effect .swiper-button-next:hover,\n.tf-sw-effect .swiper-button-prev:hover {\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);\n}\n\n.tf-sw-effect .swiper-button-next::after,\n.tf-sw-effect .swiper-button-prev::after {\n  font-size: 18px;\n  color: #000;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.tf-sw-effect .swiper-button-prev {\n  left: 6px;\n}\n\n.tf-sw-effect .swiper-button-next {\n  right: 6px;\n  top: 50%;\n}\n\n\n\n.tf-sw-effect .swiper-button-prev:disabled,\n.tf-sw-effect .swiper-button-next:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.banner-img {\n  height: auto;\n}\n\n@media only screen and (max-width: 900px) {\n  .banner-img {\n    height: 100%;\n  }\n\n  .tf-sw-effect .swiper-button-next,\n  .tf-sw-effect .swiper-button-prev {\n    width: 36px;\n    height: 36px;\n  }\n\n  .tf-sw-effect .swiper-button-next::after,\n  .tf-sw-effect .swiper-button-prev::after {\n    font-size: 16px;\n  }\n\n  .tf-sw-effect .swiper-button-prev {\n    left: 12px;\n  }\n\n  .tf-sw-effect .swiper-button-next {\n    right: 12px;\n    top: 50%;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .tf-sw-effect .swiper-button-next,\n  .tf-sw-effect .swiper-button-prev {\n    width: 32px;\n    height: 32px;\n  }\n\n  .tf-sw-effect .swiper-button-next::after,\n  .tf-sw-effect .swiper-button-prev::after {\n    font-size: 14px;\n  }\n\n  .tf-sw-effect .swiper-button-prev {\n    left: 8px;\n  }\n\n  .tf-sw-effect .swiper-button-next {\n    right: 8px;\n    top: 50%;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
